import { Button, Group, Text } from '@mantine/core'
import { observer } from 'mobx-react-lite'

import { WarningAlert } from '#components/Alerts'
import { useUpgrade } from '#components/Modals'
import { IOrg, useMst } from '#state'

export const PlanChangedCard = observer(function PlanChangedCard({
  org,
}: {
  org: IOrg
}) {
  const { user } = useMst()
  if (!org.isLapsedStripeAccount) return null

  if (!user.isCurrentOrgOwner) {
    return (
      <WarningAlert color="orange" title="This workspace’s plan has changed">
        This workspace is currently in read-only mode because the paid plan is
        no longer active. Members will be restricted to read-only access until
        the workspace is upgraded.
      </WarningAlert>
    )
  }

  if (!org.hasRestrictedMembers) return null

  return <OwnerPlanChangedAlert org={org} />
})

export const OwnerPlanChangedAlert = observer(function OwnerPlanChangedAlert({
  org,
  radius,
}: {
  org: IOrg
  radius?: number
}) {
  const { pending, upgrade } = useUpgrade()

  return (
    <WarningAlert color="orange" radius={radius} title="Your plan has changed">
      <Group align="center" gap="md" wrap="nowrap">
        <Text flex={1}>
          Your existing shared scripts are still available to view, but editing
          and collaboration require a paid plan. Members will be restricted to
          read-only access until the workspace is upgraded.
        </Text>
        <Button color="orange" loading={pending} onClick={() => upgrade(org)}>
          Manage Plan
        </Button>
      </Group>
    </WarningAlert>
  )
})
